export const HOMEPAGE = '/';
export const USER_PROFILE = '/user';
export const ORDER_HISTORY = '/useσr/history';
export const OFFERS = '/offers';
export const CATEGORIES = '/categories';
export const SMART = '/smart';
